import { render, staticRenderFns } from "./updateBusM.vue?vue&type=template&id=5190cde6&scoped=true&"
import script from "./updateBusM.vue?vue&type=script&lang=js&"
export * from "./updateBusM.vue?vue&type=script&lang=js&"
import style0 from "./updateBusM.vue?vue&type=style&index=0&id=5190cde6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5190cde6",
  null
  
)

export default component.exports